<template>
  <div>
    <announcements-tab announcements-kind="media" />
    <div class="container flexCol">
      <div class="fullWidth">
        <h1 class="pageHeading">メディア掲載</h1>
        <ul class="articleList borderLineTop">
          <li v-for="(announcement, index) in announcements" :key="index" class="articleList-item">
            <custom-nuxt-link :to="announcement.url" class="articleList-item-link">
              <div class="articleList-item-link-date">
                {{ timeConverter(announcement.display_start_on).fullDate }}
                <span v-if="isNewAnnouncement(announcement.display_start_on)" class="newLabel marginL2">NEW</span>
              </div>
              <h3 class="articleList-item-link-title">{{ announcement.title }}</h3>
              <div class="articleList-item-link-desc" v-html="$sanitizedXssHtml(announcement.content)" />
            </custom-nuxt-link>
          </li>
        </ul>
        <!-- paging -->
        <paging :current-page="currentPage" :last-page="lastPage" class="marginB4" />
      </div>
      <breadcrumbs page="medium" display-mode="footer" class="breadcrumbsFooter" />
    </div>
  </div>
</template>

<script>
import moment from 'mj-moment'
import { buildQueryString } from '@/utils/url-action'
import { timeConverter } from '@/utils/converter'
const Breadcrumbs = defineAsyncComponent(() => import('@/components/Breadcrumbs.vue'))
const SideContentPc = defineAsyncComponent(() => import('@/components/side/SideContentPc.vue'))
const Paging = defineAsyncComponent(() => import('@/components/Paging.vue'))
import { useMainStore } from '@/store'
export default {
  components: { Breadcrumbs, SideContentPc, Paging },
  async setup() {
    const app = useNuxtApp()
    const store = useMainStore()
    const route = useRoute()
    useHeadParams({ $route: route })
    const params = route.params
    const requests = []
    const publicationApiQuery = buildQueryString({ kind: 'publication', page: params.page })
    // TODO: レスポンシブシップWebを適用しているので、SP&PCの専用APIコールを分けていないです。もし性能をアップしたい場合、分けた方がいいかと思います
    const announcementRequest = store.dispatch('apiGet', `announcements/${publicationApiQuery}`).then(res => res.data)

    requests.push(announcementRequest)

    try {
      const [mainContents] = await Promise.all(requests)
      return { ...mainContents }
    } catch (e) {
      const errorCode = parseInt(e.response && e.response.status)
      await app.$error(errorCode)
    }
  },
  computed: {
    currentPage() {
      const route = useRoute()
      return Number(route.params.page) || 1
    },
    lastPage() {
      return Math.ceil(this.pagination.total_count / this.pagination.per_page) || 1
    }
  },
  methods: {
    timeConverter,
    isNewAnnouncement(date) {
      return moment().diff(date, 'day') <= 10
    }
  }
}
</script>

<style lang="scss" scoped>
.articleList {
  &-item {
    padding: 0.9rem;
    border-bottom: 1px solid $gray-c6;
    &-link {
      color: $black-1a;
      display: block;
      &:hover {
        background: $blue-lighter;
      }
      &-date {
        font-size: 1rem;
      }
      &-title {
        margin: 0.5rem 0;
        font-size: 1.4rem;
      }
      &-desc {
        font-size: 1.4rem;
      }
    }
  }
}

.newLabel {
  display: inline-block;
  padding: calc(1rem / 3) 0.5rem;
  background: $yellow;
  color: $white;
  font-size: 0.8rem;
  line-height: 1;
  white-space: nowrap;
  cursor: default;
  border-radius: 3px;
}

.fullWidth {
  width: 100%;
}

.borderLineTop {
  border-top: 1px solid $gray-c6;
}

.pageHeading {
  font-size: 2.2rem;
  font-weight: 700;
  color: $black-1a;
  margin: 1.6rem 0;
  padding: 0 1rem;
}

.flexCol {
  flex-direction: column;
}

.breadcrumbsFooter {
  width: 100%;
  margin-top: 3rem;
  margin-bottom: 6rem;
  @include pc {
    margin-top: 3rem;
    margin-bottom: 5rem;
  }
  :deep() .breadcrumbList {
    box-shadow: 0 0 3px $gray-c6;
  }
}
</style>
